<app-reset-transparency></app-reset-transparency>
<app-brightness-tool></app-brightness-tool>
<app-lasso-tool></app-lasso-tool>
<app-brush-tool></app-brush-tool>
<app-eraser-tool></app-eraser-tool>
<app-view-changes-tool></app-view-changes-tool>
<app-undo-redo></app-undo-redo>
<app-reset-changes-tool></app-reset-changes-tool>
